import type { Dispatch } from '@reduxjs/toolkit';
import type { DataRouter } from 'react-router';

import { locationChange } from './actions';

type StoreWithDispatch = {
  dispatch: Dispatch;
};

type SyncableRouter = Pick<DataRouter, 'state' | 'subscribe'>;

/**
 * Mirrors the router location in the store (`state.router`) and dispatches `LOCATION_CHANGE` once per navigation.
 * `subscribe` also fires for navigation, revalidation, fetcher and blocker transitions: the dedupe on `location.key`
 * keeps it to one dispatch per committed location.
 */
const syncRouterWithStore = (store: StoreWithDispatch, router: SyncableRouter): void => {
  let previousLocationKey = router.state.location.key;
  store.dispatch(locationChange({ location: router.state.location, action: router.state.historyAction }));

  router.subscribe((state) => {
    if (state.location.key === previousLocationKey) {
      return;
    }
    previousLocationKey = state.location.key;
    store.dispatch(locationChange({ location: state.location, action: state.historyAction }));
  });
};

export default syncRouterWithStore;
